import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin,
  Input,
  InputNumber,
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import dayjs from "dayjs";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import appStatic from "../../../../../config/appStatic";
import styles from "../../../../../assets/styles/styles";

const { Text } = Typography;

const ManageAccount = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [fixedDepositDetail, setFixedDepositDetail] = useState([]);
  const childref = useRef();

  useEffect(() => {
    getDetail();
  }, []);

  function getDetail() {
    const url = `${apiConfig.savingsAccountDetails}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false);
        const objList = res;
        setFixedDepositDetail(objList);

        {
          BOM.HasPermission("MANAGE_ACCOUNT_UPDATE") &&
            dispatch({ type: cnt.RIGHT_EDIT_BTN });
        }
      }
    });
  }

  function onCancel() {
    navigate("/detail-fixed-deposit-account", { state: state });
  }

  function handleOnEdit() {
    childref?.current?.showModal();
  }

  const items = [
    {
      label: labelConfig.daysPastDue,
      children: fixedDepositDetail?.daysPastDue
        ? fixedDepositDetail?.daysPastDue
        : fixedDepositDetail?.daysPastDue === 0
        ? "0"
        : "-",
    },
    {
      label: labelConfig.facilityReference,
      children: fixedDepositDetail?.facilityReference
        ? fixedDepositDetail?.facilityReference
        : "-",
    },

    {
      label: labelConfig.lastRateChangeDate,
      children: fixedDepositDetail?.lastRateChangeDate
        ? fixedDepositDetail?.lastRateChangeDate
        : "-",
    },
    {
      label: labelConfig.YTDInterestEarned,
      children: fixedDepositDetail?.YTDInterestEarned
        ? fixedDepositDetail?.YTDInterestEarned
        : "-",
    },
    {
      label: labelConfig.FINInterestEarned,
      children: fixedDepositDetail?.FINInterestEarned
        ? fixedDepositDetail?.FINInterestEarned
        : "-",
    },
    {
      label: labelConfig.contractReference,
      children: fixedDepositDetail?.contractReference
        ? fixedDepositDetail?.contractReference
        : "-",
    },
    {
      label: labelConfig.DSGInsuredAmount,
      children: fixedDepositDetail?.DSGInsuredAmount
        ? fixedDepositDetail?.DSGInsuredAmount?.toLocaleString()
        : "-",
    },
    {
      label: labelConfig.DSGUninsuredAmount,
      children: fixedDepositDetail?.DSGUninsuredAmount
        ? fixedDepositDetail?.DSGUninsuredAmount?.toLocaleString()
        : "-",
    },
    {
      label: labelConfig.hedgingPortfolioRef,
      children: fixedDepositDetail?.hedgingPortfolioRef
        ? fixedDepositDetail?.hedgingPortfolioRef
        : "-",
    },
    {
      label: labelConfig.repoReferenceCashLeg,
      children: fixedDepositDetail?.repoReferenceCashLeg
        ? fixedDepositDetail?.repoReferenceCashLeg
        : "-",
    },
    {
      label: labelConfig.universalSourceSystem,
      children: fixedDepositDetail?.universalSourceSystem
        ? fixedDepositDetail?.universalSourceSystem
        : "-",
    },
    {
      label: labelConfig.universalBranchId,
      children: fixedDepositDetail?.universalBranchId
        ? fixedDepositDetail?.universalBranchId
        : "-",
    },
    {
      label: labelConfig.accountHolderIndicator,
      children: fixedDepositDetail?.accountHolderIndicator
        ? fixedDepositDetail?.accountHolderIndicator
        : "-",
    },
    {
      label: labelConfig.accountStatusCode,
      children: fixedDepositDetail?.accountStatusCode
        ? fixedDepositDetail?.accountStatusCode
        : "-",
    },
    {
      label: labelConfig.extensionCode,
      children: fixedDepositDetail?.extensionCode
        ? fixedDepositDetail?.extensionCode
        : "-",
    },
    {
      label: labelConfig.jurisdiction,
      children: fixedDepositDetail?.jurisdiction
        ? fixedDepositDetail?.jurisdiction
        : "-",
    },
    {
      label: labelConfig.bankRecovery,
      children: fixedDepositDetail?.bankRecovery
        ? fixedDepositDetail?.bankRecovery
        : "-",
    },
    {
      label: labelConfig.sortCode,
      children: fixedDepositDetail?.sortCode
        ? fixedDepositDetail?.sortCode
        : "-",
    },
    {
      label: labelConfig.dormantDate,
      children: fixedDepositDetail?.dormantDate
        ? fixedDepositDetail?.dormantDate
        : "-",
    },
    {
      label: labelConfig.portfolioType,
      children: fixedDepositDetail?.portfolioType
        ? fixedDepositDetail?.portfolioType
        : "-",
    },
    {
      label: labelConfig.IFRS9PortfolioType,
      children: fixedDepositDetail?.IFRS9PortfolioType
        ? fixedDepositDetail?.IFRS9PortfolioType
        : "-",
    },
    {
      label: labelConfig.rateSpread,
      children: fixedDepositDetail?.rateSpread
        ? fixedDepositDetail?.rateSpread
        : "-",
    },
    {
      label: labelConfig.dateofPerformanceStatusChange,
      children: fixedDepositDetail?.dateofPerformanceStatusChange
        ? fixedDepositDetail?.dateofPerformanceStatusChange
        : "-",
    },
    {
      label: labelConfig.performingStatus,
      children: fixedDepositDetail?.daysPastDue
        ? fixedDepositDetail?.daysPastDue
        : "-",
    },
    {
      label: labelConfig.symmetricalInflowRate,
      children: fixedDepositDetail?.symmetricalInflowRate
        ? fixedDepositDetail?.symmetricalInflowRate
        : "-",
    },
    {
      label: labelConfig.lastInterestCapitalisationDate,
      children: fixedDepositDetail?.lastInterestCapitalisationDate
        ? fixedDepositDetail?.lastInterestCapitalisationDate
        : "-",
    },
    {
      label: labelConfig.universalHQLAIndicator,
      children: fixedDepositDetail?.universalHQLAIndicator
        ? fixedDepositDetail?.universalHQLAIndicator
        : "-",
    },
    {
      label: labelConfig.clientMoneyPlaced,
      children:
        fixedDepositDetail?.clientMoneyPlaced === true
          ? "Yes"
          : fixedDepositDetail?.clientMoneyPlaced === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.depositIban,
      children: fixedDepositDetail?.depositIban
        ? fixedDepositDetail?.depositIban
        : "-",
    },
    {
      label: labelConfig.localCurrencyCode,
      children: fixedDepositDetail?.localCurrencyCode
        ? fixedDepositDetail?.localCurrencyCode
        : "-",
    },
    {
      label: labelConfig.legallyDisputed,
      children:
        fixedDepositDetail?.legallyDisputed === true
          ? "Yes"
          : fixedDepositDetail?.legallyDisputed === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.operationalDeposit,
      children:
        fixedDepositDetail?.operationalDeposit === true
          ? "Yes"
          : fixedDepositDetail?.operationalDeposit === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.structuredDepositAccount,
      children:
        fixedDepositDetail?.structuredDepositAccount === true
          ? "Yes"
          : fixedDepositDetail?.structuredDepositAccount === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.typeofBusinessActivity,
      children: fixedDepositDetail?.typeofBusinessActivity
        ? fixedDepositDetail?.typeofBusinessActivity
        : "-",
    },
    {
      label: labelConfig.institutionWhere,
      children: fixedDepositDetail?.institutionWhere
        ? fixedDepositDetail?.institutionWhere
        : "-",
    },
    {
      label: labelConfig.typeofClientAccount,
      children: fixedDepositDetail?.typeofClientAccount
        ? fixedDepositDetail?.typeofClientAccount
        : "-",
    },
    {
      label: labelConfig.clientClientAccountAcknowledgement,
      children: fixedDepositDetail?.clientClientAccountAcknowledgement
        ? fixedDepositDetail?.clientClientAccountAcknowledgement
        : "-",
    },
    {
      label: labelConfig.linkedToPeriodic,
      children: fixedDepositDetail?.linkedToPeriodic
        ? fixedDepositDetail?.linkedToPeriodic
        : "-",
    },
    {
      label: labelConfig.universalAccumulatedImpairment,
      children: fixedDepositDetail?.universalAccumulatedImpairment
        ? fixedDepositDetail?.universalAccumulatedImpairment
        : "-",
    },
    {
      label: labelConfig.universalGLMarker,
      children: fixedDepositDetail?.universalGLMarker
        ? fixedDepositDetail?.universalGLMarker
        : "-",
    },
    {
      label: labelConfig.beneficiary,
      children: fixedDepositDetail?.beneficiary
        ? fixedDepositDetail?.beneficiary
        : "-",
    },
    {
      label: labelConfig.universalImpairmentStatus,
      children: fixedDepositDetail?.universalImpairmentStatus
        ? fixedDepositDetail?.universalImpairmentStatus
        : "-",
    },
    {
      label: labelConfig.purposeType,
      children: fixedDepositDetail?.purposeType
        ? fixedDepositDetail?.purposeType
        : "-",
    },
    {
      label: labelConfig.irregularSchedule,
      children:
        fixedDepositDetail?.irregularSchedule === true
          ? "Yes"
          : fixedDepositDetail?.irregularSchedule === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.LDStartDate,
      children: fixedDepositDetail?.LDStartDate
        ? fixedDepositDetail?.LDStartDate
        : "-",
    },
    {
      label: labelConfig.nextRolloverDate,
      children: fixedDepositDetail?.nextRolloverDate
        ? fixedDepositDetail?.nextRolloverDate
        : "-",
    },
    {
      label: labelConfig.lastRolloverDate,
      children: fixedDepositDetail?.lastRolloverDate
        ? fixedDepositDetail?.lastRolloverDate
        : "-",
    },
    {
      label: labelConfig.LDMaturityDate,
      children: fixedDepositDetail?.LDMaturityDate
        ? fixedDepositDetail?.LDMaturityDate
        : "-",
    },
    {
      label: labelConfig.repaymentType,
      children: fixedDepositDetail?.repaymentType
        ? fixedDepositDetail?.repaymentType
        : "-",
    },
    {
      label: labelConfig.originalTerm,
      children: fixedDepositDetail?.originalTerm
        ? fixedDepositDetail?.originalTerm
        : fixedDepositDetail?.originalTerm === 0
        ? "0"
        : "-",
    },
    {
      label: labelConfig.remainingTerm,
      children: fixedDepositDetail?.remainingTerm
        ? fixedDepositDetail?.remainingTerm
        : fixedDepositDetail?.remainingTerm === 0
        ? "0"
        : "-",
    },
    {
      label: labelConfig.loanPurchased,
      children:
        fixedDepositDetail?.loanPurchased === true
          ? "Yes"
          : fixedDepositDetail?.loanPurchased === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.rolloverIndicator,
      children:
        fixedDepositDetail?.rollover === true
          ? "Yes"
          : fixedDepositDetail?.rollover === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.interestMargin,
      children: fixedDepositDetail?.interestMargin
        ? fixedDepositDetail?.interestMargin
        : "-",
    },
    {
      label: labelConfig.forbearanceStatus,
      children: fixedDepositDetail?.forbearanceStatus
        ? fixedDepositDetail?.forbearanceStatus
        : "-",
    },
    {
      label: labelConfig.assessmentType,
      children: fixedDepositDetail?.assessmentType
        ? fixedDepositDetail?.assessmentType
        : "-",
    },
    {
      label: labelConfig.additionalStricterPrudentialRequirements,
      children: fixedDepositDetail?.additionalStricterPrudentialRequirements
        ? fixedDepositDetail?.additionalStricterPrudentialRequirements
        : "-",
    },
    {
      label: labelConfig.encumberedAssetFlag,
      children:
        fixedDepositDetail?.encumberedAssetFlag === true
          ? "Yes"
          : fixedDepositDetail?.encumberedAssetFlag === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.coveredByDGS,
      children:
        fixedDepositDetail?.coveredByDgs === true
          ? "Yes"
          : fixedDepositDetail?.coveredByDgs === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.accumulatedImpairmentAmount,
      children: fixedDepositDetail?.accumulatedImpairmentAmount
        ? fixedDepositDetail?.accumulatedImpairmentAmount?.toLocaleString()
        : "-",
    },
    {
      label: labelConfig.encumberedAmount,
      children: fixedDepositDetail?.encumberedAmount
        ? fixedDepositDetail?.encumberedAmount
        : "-",
    },
    {
      label: labelConfig.formalArrangement,
      children: fixedDepositDetail?.formalArrangement
        ? fixedDepositDetail?.formalArrangement
        : "-",
    },
    {
      label: labelConfig.dateOfFormalArrangement,
      children: fixedDepositDetail?.dateOfFormalArrangement
        ? fixedDepositDetail?.dateOfFormalArrangement
        : "-",
    },
    {
      label: labelConfig.temporarySwitch,
      children:
        fixedDepositDetail?.intOnlyTempSwitch === true
          ? "Yes"
          : fixedDepositDetail?.intOnlyTempSwitch === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.dateOfInterestOnly,
      children: fixedDepositDetail?.dateOfInterestOnly
        ? fixedDepositDetail?.dateOfInterestOnly
        : "-",
    },
    {
      label: labelConfig.paymentsSuspended,
      children:
        fixedDepositDetail?.paymentsSuspendedInd === true
          ? "Yes"
          : fixedDepositDetail?.paymentsSuspendedInd === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.datePaymentsSuspended,
      children: fixedDepositDetail?.datePaymentsSuspended
        ? fixedDepositDetail?.datePaymentsSuspended
        : "-",
    },
    {
      label: labelConfig.reducedPayment,
      children:
        fixedDepositDetail?.reducedPaymentInd === true
          ? "Yes"
          : fixedDepositDetail?.reducedPaymentInd === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.dateOfReducedPayment,
      children: fixedDepositDetail?.dateOfReducedPayment
        ? fixedDepositDetail?.dateOfReducedPayment
        : "-",
    },
    {
      label: labelConfig.termExtension,
      children: fixedDepositDetail?.termExtension
        ? fixedDepositDetail?.termExtension
        : "-",
    },
    {
      label: labelConfig.dateOfTermExtension,
      children: fixedDepositDetail?.dateOfTermExtension
        ? fixedDepositDetail?.dateOfTermExtension
        : "-",
    },
    {
      label: labelConfig.otherForbearance,
      children:
        fixedDepositDetail?.otherForbearanceInd === true
          ? "Yes"
          : fixedDepositDetail?.otherForbearanceInd === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.dateOfOtherForbearance,
      children: fixedDepositDetail?.dateOfOtherForbearance
        ? fixedDepositDetail?.dateOfOtherForbearance
        : "-",
    },
    {
      label: labelConfig.dateLitigationAction,
      children: fixedDepositDetail?.dateLitigationAction
        ? fixedDepositDetail?.dateLitigationAction
        : "-",
    },
    {
      label: labelConfig.nonPerformingBeforeForbearance,
      children:
        fixedDepositDetail?.nonPerforming === true
          ? "Yes"
          : fixedDepositDetail?.nonPerforming === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.LTV,
      children: fixedDepositDetail?.daysPastDue
        ? fixedDepositDetail?.daysPastDue
        : "-",
    },
    {
      label: labelConfig.universalInterestOnMaturity,
      children: fixedDepositDetail?.universalInterestOnMaturity
        ? fixedDepositDetail?.universalInterestOnMaturity
        : "-",
    },
    {
      label: labelConfig.coverPoolID,
      children: fixedDepositDetail?.coverPoolID
        ? fixedDepositDetail?.coverPoolID
        : "-",
    },
    {
      label: labelConfig.centralBankEligible,
      children:
        fixedDepositDetail?.centralBankEligible === true
          ? "Yes"
          : fixedDepositDetail?.centralBankEligible === false
          ? "No"
          : "-",
    },
    {
      label: labelConfig.nettingFlag,
      children: fixedDepositDetail?.nettingFlag
        ? fixedDepositDetail?.nettingFlag
        : "-",
    },
    {
      label: labelConfig.impairmentStartDate,
      children: fixedDepositDetail?.impairmentStartDate
        ? fixedDepositDetail?.impairmentStartDate
        : "-",
    },
    {
      label: labelConfig.interestReversionDate,
      children: fixedDepositDetail?.interestReversionDate
        ? fixedDepositDetail?.interestReversionDate
        : "-",
    },
    {
      label: labelConfig.loanCollateralPool,
      children: fixedDepositDetail?.loanCollateralPool
        ? fixedDepositDetail?.loanCollateralPool
        : "-",
    },
    {
      label: labelConfig.applicationReference,
      children: fixedDepositDetail?.applicationReference
        ? fixedDepositDetail?.applicationReference
        : "-",
    },
    {
      label: labelConfig.accountDescription,
      children: fixedDepositDetail?.accountDescription
        ? fixedDepositDetail?.accountDescription
        : "-",
    },
    {
      label: labelConfig.transferableEligibleDeposit,
      children: fixedDepositDetail?.transferableEligibleDeposit
        ? fixedDepositDetail?.transferableEligibleDeposit?.toLocaleString()
        : "-",
    },
  ];

  return (
    <MainLayout isEnableRightSidebar={true} onEdit={() => handleOnEdit()}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.manageFixedDepositAccountDetails}
        pageItems={staticConfig.manageAccountDetailsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            ...styles.cardWithCustomHeight,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical">
            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />

            <Row>
              <EditModal userData={userData} ref={childref} state={state} />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default ManageAccount;

const EditModal = forwardRef((props, ref) => {
  const { userData, state } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();

  const [editFixedDepositDetail, setEditFixedDepositDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = "YYYY/MM/DD";

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getTemplate();
    defaultDate();
  }, []);

  const defaultDate = () => {
    useForm.setFieldsValue({
      datePastDue: dayjs(),
      ldMaturityDate: dayjs(),
      ldStartDate: dayjs(),
      dateLastIntCap: dayjs(),
      perfStatusChangeDate: dayjs(),
      dormantDate: dayjs(),
      lastRateChangeDate: dayjs(),
      dateOtherForbearance: dayjs(),
      dateTermExtension: dayjs(),
      dateIntSwitch: dayjs(),
      dateFormalArrangement: dayjs(),
      lastRolloverDate: dayjs(),
      nextRolloverDate: dayjs(),
      dateIntReversion: dayjs(),
      dateImpairmentStart: dayjs(),
      dateLitigationStart: dayjs(),
      dateIntReversion: dayjs(),
      lastTransactionDate: dayjs(),
      dateReducedPayment: dayjs(),
    });
  };

  function getTemplate() {
    const url = `${apiConfig.savingsAccountDetails}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false);
        const objList = res;

        setEditFixedDepositDetail(objList);
      }
    });
  }

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.savingsAccountDetails}`;

    formValues.datePastDue = formValues.datePastDue
      ? BOM.DateTime(formValues.datePastDue, "only-date")
      : formValues.datePastDue;

    formValues.dateIntSwitch = formValues.dateIntSwitch
      ? BOM.DateTime(formValues.dateIntSwitch, "only-date")
      : formValues.dateIntSwitch;

    formValues.dateFormalArrangement = formValues.dateFormalArrangement
      ? BOM.DateTime(formValues.dateFormalArrangement, "only-date")
      : formValues.dateFormalArrangement;

    formValues.lastRolloverDate = formValues.lastRolloverDate
      ? BOM.DateTime(formValues.lastRolloverDate, "only-date")
      : formValues.lastRolloverDate;

    formValues.nextRolloverDate = formValues.nextRolloverDate
      ? BOM.DateTime(formValues.nextRolloverDate, "only-date")
      : formValues.nextRolloverDate;

    formValues.dateImpairmentStart = formValues.dateImpairmentStart
      ? BOM.DateTime(formValues.dateImpairmentStart, "only-date")
      : formValues.dateImpairmentStart;

    formValues.dateLitigationStart = formValues.dateLitigationStart
      ? BOM.DateTime(formValues.dateLitigationStart, "only-date")
      : formValues.dateLitigationStart;

    formValues.dateIntReversion = formValues.dateIntReversion
      ? BOM.DateTime(formValues.dateIntReversion, "only-date")
      : formValues.dateIntReversion;

    formValues.lastTransactionDate = formValues.lastTransactionDate
      ? BOM.DateTime(formValues.lastTransactionDate, "only-date")
      : formValues.lastTransactionDate;

    formValues.dateReducedPayment = formValues.dateReducedPayment
      ? BOM.DateTime(formValues.dateReducedPayment, "only-date")
      : formValues.dateReducedPayment;

    formValues.dateIntSwitch = formValues.dateIntSwitch
      ? BOM.DateTime(formValues.dateIntSwitch, "only-date")
      : formValues.dateIntSwitch;

    formValues.dateTermExtension = formValues.dateTermExtension
      ? BOM.DateTime(formValues.dateTermExtension, "only-date")
      : formValues.dateTermExtension;

    formValues.dateOtherForbearance = formValues.dateOtherForbearance
      ? BOM.DateTime(formValues.dateOtherForbearance, "only-date")
      : formValues.dateOtherForbearance;

    formValues.lastRateChangeDate = formValues.lastRateChangeDate
      ? BOM.DateTime(formValues.lastRateChangeDate, "only-date")
      : formValues.lastRateChangeDate;

    formValues.dormantDate = formValues.dormantDate
      ? BOM.DateTime(formValues.dormantDate, "only-date")
      : formValues.dormantDate;

    formValues.perfStatusChangeDate = formValues.perfStatusChangeDate
      ? BOM.DateTime(formValues.perfStatusChangeDate, "only-date")
      : formValues.perfStatusChangeDate;

    formValues.dateLastIntCap = formValues.dateLastIntCap
      ? BOM.DateTime(formValues.dateLastIntCap, "only-date")
      : formValues.dateLastIntCap;

    formValues.ldStartDate = formValues.ldStartDate
      ? BOM.DateTime(formValues.ldStartDate, "only-date")
      : formValues.ldStartDate;

    formValues.ldMaturityDate = formValues.ldMaturityDate
      ? BOM.DateTime(formValues.ldMaturityDate, "only-date")
      : formValues.ldMaturityDate;

    formValues.local_currency_code = "GBP";
    formValues.savingsAccountId = state.id;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Manage Fixed Deposit Account"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            onFinish={onSubmit}
            initialValues={{
              nonPerforming: false,
              stressWithdrawal: false,
              transactionalAccount: false,
              suspectedMoneyLaundering: false,
              fraud: false,
              legallyDisputed: false,
              undocumentedAccount: false,
              operationalDeposit: false,
              structuredDepositAccount: false,
              symmetricalInflowRate: false,
              clientMoneyPlaced: false,
              acknowledgementLetter: false,
              transactionalAccountBranchReturn: false,
              beneficiary: false,
              irregularSchedule: false,
              loanPurchased: false,
              rollover: false,
              strictPrudential: false,
              formalShortfall: false,
              encumberedAsset: false,
              coveredByDgs: false,
              intOnlyTempSwitch: false,
              paymentsSuspendedInd: false,
              reducedPaymentInd: false,
              termExtensionInd: false,
              otherForbearanceInd: false,
              nonPerfBeforeForbear: false,
              centralBankEligible: false,
              centralBankEligible: false,
            }}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
        styles={{
          body: { overflowY: "auto", maxHeight: "calc(100vh - 300px)" },
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.datePastDue} name="datePastDue">
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.daysPastDue} name="daysPastDue">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.daysPastDue}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.lastRateChangeDate}
                name="lastRateChangeDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.nonPerforming} name="nonPerforming">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  defaultValue={"No"}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.stressWithdrawal}
                name="stressWithdrawal"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  defaultValue={"No"}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.FINInterestEarned}
                name="finYtdInterestEarned"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.FINInterestEarned}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.YTDInterestEarned}
                name="ytdInterestEarned"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.YTDInterestEarned}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contractReference}
                name="contractReference"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.contractReference}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.DSGInsuredAmount}
                name="dsgInsuredAmount"
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.DSGInsuredAmount}`,
                    "select"
                  )}
                  style={{ width: "100%" }}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.DSGUninsuredAmount}
                name="dsgUninsuredAmount"
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.DSGUninsuredAmount}`,
                    "select"
                  )}
                  style={{ width: "100%" }}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.hedgingPortfolioRef}
                name="hedgingPortfolioRef"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.hedgingPortfolioRef}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.repoReferenceCashLeg}
                name="repoReferenceCashLeg"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.repoReferenceCashLeg}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.universalSourceSystem}
                name="universalSourceSystem"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.suspectedLaundering}
                name="suspectedMoneyLaundering"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionalAccount}
                name="transactionalAccount"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.fraud} name="fraud">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.legallyDisputed}
                name="legallyDisputed"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.undocumentedAcc}
                name="undocumentedAccount"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.structuredDepositAcc}
                name="structuredDepositAccount"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.operationalDeposit}
                name="operationalDeposit"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Divider orientation="left"> </Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.universalBranchId}
                name="universalBranchId"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.universalBranchId}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountStatusCode}
                name="accountStatusCode"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.accountStatusCode}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.jurisdiction} name="jurisdiction">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.jurisdiction}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transferableEligibleDeposit}
                name="transferableEligibleDeposit"
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.transferableEligibleDeposit}`,
                    "select"
                  )}
                  style={{ width: "100%" }}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountHolderIndicator}
                name="accountHolderIndicator"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.accountHolderIndicator}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.extensionCode} name="extensionCode">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.extensionCode}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.bankRecovery} name="bankRecovery">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.bankRecovery}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.sortCode} name="sortCode">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.sortCode}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.dormantDate} name="dormantDate">
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.facilityReference}
                name="facilityId"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.facilityReference}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.debitInterestRate}
                name="debitInterestRate"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.debitInterestRate}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.portfolioType} name="portfolioType">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.portfolioType}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.IFRS9PortfolioType}
                name="ifrsPortfolioType"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.IFRS9PortfolioType}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.rateSpread} name="rateSpread">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.rateSpread}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfPerformance}
                name="perfStatusChangeDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.performingStatus}
                name="performingStatus"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.lastInterestCapitalisationDate}
                name="dateLastIntCap"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.symmetricalInflowRate}
                name="symmetricalInflowRate"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.universalHqla} name="universalHqla">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.clientMoneyPlaced}
                name="clientMoneyPlaced"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.typeOfBusinessActivity}
                name="typeBusinessActivity"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.typeOfBusinessActivity}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.instWhereClientMoneyIsPaid}
                name="instMoneyPlaced"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.instWhereClientMoneyIsPaid}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.typeOfClientAccForCass}
                name="typeOfClientAccForCass"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.clientClientAccountAcknowledgement}
                name="acknowledgementLetter"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.linkedToPeriodic} name="intRateId">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.linkedToPeriodic}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.universalAccumulatedImpairment}
                name="accumulatedImpairmentAmount"
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.universalAccumulatedImpairment}`,
                    "select"
                  )}
                  style={{ width: "100%" }}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionalAccountBranchReturn}
                name="transactionalAccountBranchReturn"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.universalGlMarker} name="altId">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.universalGlMarker}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.lastCstDrivenTransaction}
                name="lastTransactionDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.purposeType} name="purposeType">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.purposeType}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.beneficiary} name="beneficiary">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.irregularSchedule}
                name="irregularSchedule"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.LDStartDate} name="ldStartDate">
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.LDMaturityDate}
                name="ldMaturityDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.nextRollOverDate}
                name="nextRolloverDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.lastRollOverDate}
                name="lastRolloverDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.repaymentType} name="repaymentType">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.originalTerm} name="originalTerm">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.originalTerm}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.remainingTerm} name="remainingTerm">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.remainingTerm}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.assessmentType}
                name="assessmentType"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.assessmentType}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.interestMargin}
                name="interestMargin"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.interestMargin}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.loanPurchased} name="loanPurchased">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.rollOverIndicator} name="rollover">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.additionalStricter}
                name="strictPrudential"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.formalArrangement}
                name="formalShortfall"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.encumberedAssetFlag}
                name="encumberedAsset"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.coveredByDGS} name="coveredByDgs">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.encumberedAmount}
                name="encumberedAmount"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.temporarySwitch}
                name="intOnlyTempSwitch"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.paymentsSuspended}
                name="paymentsSuspendedInd"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.reducedPayment}
                name="reducedPaymentInd"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.termExtension}
                name="termExtensionInd"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otherForBearance}
                name="otherForbearanceInd"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.nonPerformingBeforeForbearance}
                name="nonPerfBeforeForbear"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.centralBankEligibleFlag}
                name="centralBankEligible"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.option}`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfFormalArrangement}
                name="dateFormalArrangement"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfInterestOnly}
                name="dateIntSwitch"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfTermExtension}
                name="dateTermExtension"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfOtherForBearance}
                name="dateOtherForbearance"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateLitigationAction}
                name="dateLitigationStart"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.LTV} name="ltv">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.LTV}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.universalInterestOnMaturity}
                name="maturityInterestAmount"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.universalInterestOnMaturity}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.coverPoolID} name="coverPoolId">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.coverPoolID}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.nettingFlag} name="nettingInd">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.nettingFlag}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.impairmentStartDate}
                name="dateImpairmentStart"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.interestReversionDate}
                name="dateIntReversion"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.loanCollateralPool}
                name="collateralPoolId"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.loanCollateralPool}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.applicationReference}
                name="applicationId"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.applicationReference}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfReducedPayment}
                name="dateReducedPayment"
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.localCurrencyCode}
                name="localCurrencyCode"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.localCurrencyCode}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountBalanceLocalCurrency}
                name="accountBalanceLocalCurrency"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.accountBalanceLocalCurrency}`,
                    "select"
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});
